import { apiUrl } from "../api/endpoints";
import React, { useState, useContext } from 'react';
import '../Components/modal.css';
import axios from 'axios';

import { useAuth } from '../hooks/AuthProvider';
import Alert from '../Components/Alert';

import { LanguageContext } from '../context/LanguageContext';
import roleTranslations from '../languages/role.json';
import { getErrorMessage } from '../utils/errorUtils';
import { AddNewIcon, NameIcon } from '../svg/UtilsIcons';

export const AddRole = ({ refresh, setState }) => {
  const { permissions } = useAuth();
  const { lang } = useContext(LanguageContext);

  const canAddRoles = permissions['add_roles'];

  const t = roleTranslations[lang]?.addRole || {};
  const isRtl = ['ar', 'ur'].includes(lang);

  const [formData, setFormData] = useState({
    name: ''
  });
  const [loading, setLoading] = useState(false);

  const [alertState, setAlertState] = useState({
    open: false,
    message: '',
    type: 'info',
    position: isRtl ? 'left' : 'right'
  });

  const showAlert = (type, message) => {
    setAlertState({ open: true, type, message, position: isRtl ? 'left' : 'right' });
  };

  const createRole = async () => {
    if (loading) return;

    if (!formData.name || formData.name.trim() === '') {
      showAlert('error', t.validation?.nameRequired || 'Role name is required.');
      return;
    }

    const body = {
      name: formData.name.trim()
    };

    setLoading(true);
    try {
      const res = await axios.post(
        apiUrl(`roles`),
        body,
        { headers: { 'Content-Type': 'application/json' } }
      );

      showAlert(
        'success',
        res.data.message || t.successMessage || 'Role created successfully.'
      );

      refresh();

      setTimeout(() => {
        setState(false);
      }, 1500);
    } catch (err) {
      const errorMessage = getErrorMessage(err);
      showAlert('error', errorMessage);
      setLoading(false);
    }
  };


  if (!canAddRoles) {
    return (
      <div
        id="modal"
        style={{ direction: isRtl ? 'rtl' : 'ltr' }}
      >
        <div
          id="popup"
          className="dashboard-modal"
          style={{
            animationName: isRtl ? 'reverse-add-zoom' : 'add-zoom',
            fontSize:
              'calc(var(--body-font-size) * var(--font-size-multiplier))'
          }}
        >
          <div className="dashboard-header">
            <div className="dashboard-header-icon">
              <AddNewIcon />
            </div>
            <div className="dashboard-header-text">
              <h2>{t.permissionDenied?.title || 'Permission Denied'}</h2>
              <p>
                {t.permissionDenied?.message ||
                  'You do not have permission to add roles.'}
              </p>
            </div>
          </div>

          <div className="modal-divider" />

          <div className="modal-content dashboard-content" />

          <div className="modal-footer dashboard-footer">
            <button
              className="btn btn-cancel"
              onClick={() => setState(false)}
            >
              {t.buttonClose || 'Close'}
            </button>
            <div />
          </div>
        </div>
      </div>
    );
  }


  return (
    <div
      id="modal"
      style={{ direction: isRtl ? 'rtl' : 'ltr' }}
    >
      <Alert
        open={alertState.open}
        close={() => setAlertState({ ...alertState, open: false })}
        message={alertState.message}
        type={alertState.type}
        position={alertState.position}
      />

      <div
        id="popup"
        className="dashboard-modal"
        style={{
          animationName: isRtl ? 'reverse-add-zoom' : 'add-zoom',
          fontSize:
            'calc(var(--body-font-size) * var(--font-size-multiplier))'
        }}
        onClick={e => e.stopPropagation()}
      >
        <div className="dashboard-header">
          <div className="dashboard-header-icon">
            <AddNewIcon />
          </div>
          <div className="dashboard-header-text">
            <h2>{t.title || 'New Roles'}</h2>
            <p>
              {t.subtitle ||
                t.description ||
                'Define a new access role for your users.'}
            </p>
          </div>
        </div>

        <div className="modal-divider" />

        <div className="modal-content dashboard-content">
          <div className="form-section">
            <div className="form-section-title">
              <span className="form-section-icon">
                <NameIcon />
              </span>
              <span className="form-section-title-text">
                {t.labelRoleName || 'Role Name'}
              </span>
            </div>

            <div className="form-item">
              <div className="field-with-counter">
                <input
                  type="text"
                  className="add-column"
                  name="name"
                  placeholder={t.placeholderName || 'Enter Role name'}
                  maxLength={50}
                  value={formData.name}
                  onChange={e =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  disabled={loading}
                />
                <span className="field-counter">
                  {(formData.name?.length || 0)} / 50
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer dashboard-footer">
          <button
            className="btn btn-cancel"
            onClick={() => setState(false)}
            disabled={loading}
          >
            {t.buttonCancel || 'Cancel'}
          </button>
          <button
            className="btn btn-apply dashboard-primary-btn"
            onClick={createRole}
            disabled={loading}
          >
            {loading ? '...' : t.buttonCreate || 'Create Role'}
          </button>
        </div>
      </div>
    </div>
  );
};
